<template>
    <div>
        <a-form layout="inline" class="mb-20">
            <a-form-item label="操作类型">
                <a-select allowClear v-model="dataForm.log_type" style="width: 120px" placeholder="可选类型">
                    <a-select-option value="2">新增</a-select-option>
                    <a-select-option value="3">修改</a-select-option>
                    <a-select-option value="4">删除</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button @click="getDataList">搜索</a-button>
            </a-form-item>
        </a-form>
        <a-timeline>
            <a-timeline-item v-for="v in dataList"
                :color="v.log_type == '2' ? 'green' : v.log_type == '3' ? 'orange' : v.log_type == '4' ? 'red' : ''">
                <div>{{ v.content }}</div>
                <p>操作人：{{ v.userinfo && v.userinfo.real_name ? v.userinfo.real_name : '' }}｜{{ v.create_time }}</p>
            </a-timeline-item>
        </a-timeline>
        <a-pagination size="small" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
    </div>
</template>
<script>
import viewModule from "@/mixins/view-module";
export default {
    mixins: [viewModule],
    props: ['haibaoid'],
    data() {
        return {
            dataForm: {
                haibaoid: this.haibaoid,
                log_type: undefined
            },
            mixinViewModuleOptions: {
                createdIsNeed: true,
                getDataListURL: "/admin/haibaoitemlog/page",
            },
        }
    },
}
</script>